// extracted by mini-css-extract-plugin
module.exports = {"stars":"_6c97079b1b--stars--fYyv3","stars-size_s":"_6c97079b1b--stars-size_s--SapuP","stars-size_m":"_6c97079b1b--stars-size_m--rwvGV"};